import { AnyObject } from "../models";

export const ErrorCode = {
  unknown: 1,
  invalidParams: 103,
  unauthorized: 401,
  permissionDenied: 403,
  objectNotFound: 404,
  rateLimited: 429,
  serverError: 500,
  serviceUnavailable: 503,

  needsAdditionalConfirmation: 444,

  deprecatedAction: 900,
  deprecatedApi: 901,
  // Kits
  kitNotFound: 1100,
  kitAleadyExists: 1101,
  kitNotAccepted: 1102,
  versionNotFound: 1200,
  // Kit Collections
  kitCollectionAlreadyExists: 6101,
  kitCollectionNotFound: 6404,
  kitCollectionItemNotFound: 61404,
  // Sections
  sectionNotFound: 2100,
  sectionAlreadyExists: 2101,
  sectionNotAccepted: 2102,
  // Assets
  assetNotFound: 3100,
  assetAlreadyExists: 3101,
  assetNotAccepted: 3102,
  assetReferenceDenied: 3106,
  // Files
  fileTooLarge: 413,
  fileNotValid: 3300,
  fileNotAccepted: 3302,
  fileCutUnavailable: 3304,
  filePreviewUnavailable: 3305,
  // Items
  itemNotFound: 3200,
  itemAlreadyExists: 3201,
  itemNotAccepted: 3202,
  // Users
  userNotFound: 5100,
  userAlreadyExists: 5101,
  userNotActive: 5102,
  // Space
  spaceNotAccepted: 7102,
  spaceNotFound: 7101,
  spaceMemberLimitReached: 7103,
  featureUnavailable: 7104,
  // Invitations & Joining
  invitationAlreadyAccepted: 7201,
  invitationNotFound: 7204,
  joinLinkNotValid: 7304,
  // SSO
  organizationNotFound: 8101,
  organizationNotConfigured: 8304,
  invalidSsoToken: 8305,
  organizationInviteNeeded: 8403,
  // Figma Auth
  figmaAuthNotFound: 10404,
  figmaAuthInvalid: 10403,
  // Figma import
  figmaInvalidType: 11103,
  figmaNotFound: 11404,
  figmaRateLimited: 11503,
  // Fields
  fieldNotFound: 12404,
  fieldLimitReached: 12103,
  // Field options
  optionNotFound: 13404,
  // MFA
  totpRequired: 14403,
  totpInvalid: 14401,
  totpAlreadyUsed: 14101,
  // Google Auth
  googleAuthConfirmationRequired: 15101,
  // Download requests
  downloadRequiresIdentity: 16401,
  downloadRequiresVerifiedIdentity: 16403,
  downloadRequestPending: 16800,
  downloadRequestDenied: 16801,

  // Payment
  paymentError: 9100,

  // Portal
  portalNotFound: 17404,
  // PIM - Product Types
  productTypeNotFound: 18404,
  productNotFound: 19404,
  variantNotFound: 20404,
} as const;

export type LingoError = {
  code: number;
  message: string;
  details?: AnyObject;
  recovery?: AnyObject;
  status?: string;
};

const validCodes = new Set(Object.values(ErrorCode));
export function isError(obj: AnyObject): obj is LingoError {
  return (
    obj &&
    obj instanceof Error === false &&
    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
    validCodes.has(obj.code) &&
    obj.message
  );
}
